import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ResetEmailState {
  email: string | null;
  setEmail: (email: string) => void;
  clear: () => void;
}

export const useResetEmailStore = create<ResetEmailState>()(
  persist(
    (set) => ({
      email: null,
      setEmail: (email) => set({ email }),
      clear: () => set({ email: null }),
    }),
    {
      name: 'lx.resetEmail',
      version: 1,
    },
  ),
);
